/**
 * @generated SignedSource<<f4b3a419f59c392b6d6f0b59c3a5fe67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActivityTab_activity$data = ReadonlyArray<{
  readonly __typename: string;
  readonly createdAt?: string;
  readonly " $fragmentSpreads": FragmentRefs<"ActivityTimelineItem_activity">;
  readonly " $fragmentType": "ActivityTab_activity";
}>;
export type ActivityTab_activity$key = ReadonlyArray<{
  readonly " $data"?: ActivityTab_activity$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActivityTab_activity">;
}>;

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ActivityTab_activity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "MessageActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "InternalCommentActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "EventActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "AttachmentActivity",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ActivityTimelineItem_activity"
    }
  ],
  "type": "ActivityEvent",
  "abstractKey": "__isActivityEvent"
};
})();

(node as any).hash = "b36aa5fbea10b104bc415fc4047eccbd";

export default node;
